// Formato de dinero comun para toda la app: x,xxx.xx
// (coma de miles, punto decimal, SIEMPRE 2 decimales). Se usa un unico formateador
// para que un precio se vea igual en el panel admin, el POS, la app del cliente y
// los tickets impresos.
const MONEY_FORMAT = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// Numero limpio: NaN/Infinity/null -> 0.00 (los totales parciales nunca deben
// pintarse como "NaN" en un ticket).
export const formatAmount = (value) => {
  const n = typeof value === 'number' ? value : parseFloat(value);
  return MONEY_FORMAT.format(Number.isFinite(n) ? n : 0);
};

// Precio con simbolo: formatPrice(1234.5) -> "$1,234.50"
export const formatPrice = (value, symbol = '$') => `${symbol}${formatAmount(value)}`;
